    var divBox = document.getElementsByClassName('bb-product__box');
    var addBoxToBuilder = document.getElementsByClassName('bb-btn_product--full');
    var boxSummary = document.getElementsByClassName('rt-BaseCard')[0];
    var boxListProducts = document.getElementsByClassName('bxp-box-list');
    var infoPrice = document.getElementById('bxp-bldr-price_total');
    var infoIcon = document.getElementById('bxp-bldr-details_bt');

window.addEventListener('load', function() {

    var url = document.URL;
    const prefix = "https://amyi.co/apps/builder";
    
    if (url.startsWith(prefix)) {
      
    setInterval( function(){
      clearContentsExp()
    }, 10)

    for (var i = 0; i < addBoxToBuilder.length; i++) {

    if(divBox.length <= 19 && i != 0){
      addBoxToBuilder[i].setAttribute('onclick', 'verifyExp();');
    }

    if(divBox.length > 19 && i!= 0 && i != 1){
      addBoxToBuilder[i].setAttribute('onclick', 'verifyExp();');
    }
      
  }
      
  
    if(divBox.length >= 17){
    
    divBox[0].style.display = 'none';
      
    if(divBox[1].childNodes[0].firstChild.lastChild.children[0].parentNode.children[0].lastChild.innerText == 'Perfume em 100ml a ser escolhido posteriormente' || divBox[1].childNodes[0].firstChild.lastChild.children[0].parentNode.children[0].lastChild.innerText == 'Perfume em 100ml a ser escolhido posteriormente - EAP'){
      divBox[1].style.display = 'none';
    }
    var existBoxPremium = false;
    var existPerfumPremium = false;

    for(var i = 0; i < boxSummary.length; i++){
      
      if(boxSummary[i].children[1].children[1].childNodes[1].firstChild.src.toLowerCase().includes("caixa") == true){
        existBoxPremium = true;
      }
      if(boxSummary[i].children[1].children[1].childNodes[1].firstChild.src.toLowerCase().includes("100ml") == true){
        existPerfumPremium = true;
      }
    }

    if(existBoxPremium == false){
      addBoxToBuilder[0].click();
    }
    if(existPerfumPremium == false){
      if(divBox[1].childNodes[0].firstChild.lastChild.children[0].parentNode.children[0].lastChild.innerText == 'Perfume em 100ml a ser escolhido posteriormente' || divBox[1].childNodes[0].firstChild.lastChild.children[0].parentNode.children[0].lastChild.innerText == 'Perfume em 100ml a ser escolhido posteriormente - EAP'){
        addBoxToBuilder[1].click();
      }
    }
    
  }

    }
    
})  

function verifyExp(){
    if(divBox[1] != undefined && (divBox[1].childNodes[0].firstChild.lastChild.children[0].parentNode.children[0].lastChild.innerText == 'Perfume em 100ml a ser escolhido posteriormente' || divBox[1].childNodes[0].firstChild.lastChild.children[0].parentNode.children[0].lastChild.innerText == 'Perfume em 100ml a ser escolhido posteriormente - EAP') ){


    var newBoxSummary = document.getElementsByClassName('rt-variant-surface');
    let elements = newBoxSummary[0].children[1].children;
    var existCaixa = [];
    var existPerfumPremium = [];
    for (let i = 0; i < elements.length; i++) {
        let element = elements[i];

          if(element.children[1].children[0].src.toLowerCase().includes("caixa") == true){
                existCaixa.push(true);
                element.style.display = 'none';
          }

          if(element.children[1].children[0].src.toLowerCase().includes("100ml") == true){
              existPerfumPremium.push(true);
              element.style.display = 'none';
          }
    }

    if(existCaixa.length < 1){
      addBoxToBuilder[0].click();
    }

    if(existPerfumPremium.length < 1){
      addBoxToBuilder[1].click();
    }
      
  }
  if(divBox[1].childNodes[0].firstChild.lastChild.children[0].parentNode.children[0].lastChild.innerText != 'Perfume em 100ml a ser escolhido posteriormente' && divBox[1].childNodes[0].firstChild.lastChild.children[0].parentNode.children[0].lastChild.innerText != 'Perfume em 100ml a ser escolhido posteriormente - EAP'){

    var newBoxSummary = document.getElementsByClassName('rt-variant-surface');
    let elements = newBoxSummary[0].children[1].children;
    var existCaixa = [];
    for (let i = 0; i < elements.length; i++) {
        let element = elements[i];

          if(element.children[1].children[0].src.toLowerCase().includes("caixa") == true){
                existCaixa.push(true);
                element.style.display = 'none';
          }
    }

    if(existCaixa.length < 1){
      addBoxToBuilder[0].click();
    }
    
  }
}


function clearContentsExp(){

    var verifySummary = document.getElementsByClassName('rt-variant-surface');
    let elementsSummary = verifySummary[0].children[1].children;
    
    for (let iSummary = 0; iSummary < elementsSummary.length; iSummary++) {
        let elementSummary = elementsSummary[iSummary];
          if(elementSummary.children[1].children[0].src.toLowerCase().includes("caixa") == true){
                elementSummary.style.display = 'none';
          }

          if(elementSummary.children[1].children[0].src.toLowerCase().includes("100ml") == true){
              elementSummary.style.display = 'none';
          }
    }

}
